$(document).ready(function () {
  $('.user-background').on('click', function () {
    $('.tm_header-dropdown .my-account').slideToggle();
    $('.tm_header-dropdown').toggleClass('active');
  });
});

function responsivecolumn() {
  if ($(document).width() <= 989) {
    $('.header-top .header-top-inner .header-top-left .header-top__link').appendTo('#menu-drawer.main-menu .menu-drawer__navigation-container .menu-drawer__navigation');
  } else {
    $('#menu-drawer.main-menu .menu-drawer__navigation-container .menu-drawer__navigation .header-top__link').prependTo('.header-top .header-top-inner .header-top-left');
  }
}

$(document).ready(function () {
  responsivecolumn();
});

$(window).on('resize', function () {
  responsivecolumn();
});
